<template>
  <v-flex mb-4>
    <v-container>
      <h1 class="mb-5 mt-2 d-flex align-center">
        <v-icon class="mr-3" large>mdi-view-dashboard</v-icon>
        <span>Dashboard</span>
      </h1>

      <v-row>
        <dashboard-menu
          v-for="card in cards"
          :key="card.title"
          :title="card.title"
          :icon="card.icon"
          :color="card.color"
          :text="card.text"
          :link="card.link"
        ></dashboard-menu>
      </v-row>
      <v-container>
        <recent-activities />
      </v-container>
    </v-container>
  </v-flex>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue'
import RecentActivities from '@/components/RecentActivities.vue'

export default {
  name: 'dashboard',
  title: 'dashboard',
  components: {
    DashboardMenu,
    RecentActivities,
  },

  data: () => ({
    cards: [
      {
        title: 'Database',
        icon: 'mdi-database',
        color: '#87CEEB',
        text: 'Upload, manage and share your data!',
        link: '/brains/list',
      },

      {
        title: 'Notebook',
        icon: 'mdi-notebook',
        color: '#008000',
        text: 'Analize your data.<br>Create beautiful graphs.',
        link: '/notebooks/list',
      },
      {
        title: 'Studio',
        icon: 'mdi-movie-open-outline',
        color: '#FFA400',
        text: 'Visualize the brains in 3D. Make cool animations.',
        link: '/studios/list',
      },
      {
        title: 'Repository',
        icon: 'mdi-earth',
        color: '#0000FF',
        text: 'View and download the published data.',
        link: '/brains/public',
      },
      {
        title: 'Learn',
        icon: 'mdi-book-open-page-variant',
        color: '#E9967A',
        text: 'Read the documentation.',
        link: '/docs/home',
      },
      {
        title: 'Account',
        icon: 'mdi-account-circle',
        color: '#DCDCDC',
        text: 'Account settings.',
        link: '/account/profile',
      },
    ],
  }),
}
</script>
